import "./Conversation.scss";

import React from "react";

import Loading from "../../../components/Loading";
import Post from "./Post";

const Conversation = ({ thread, refreshing, reservation, booking }) => {
  const posts = thread.posts;
  const checkinDate = reservation?.checkin_date || booking?.checkin;
  const checkoutDate = reservation?.checkout_date || booking?.checkout;
  const numberOfGuests = reservation?.number_of_guests || booking?.num_guests;

  return (
    <div className="Conversation">
      {refreshing && (
        <Loading
          className="Conversation__loading"
          message="Loading new messages..."
        />
      )}

      {posts.map(post => (
        <Post
          key={post.created_at}
          post={post}
          checkinDate={checkinDate}
          checkoutDate={checkoutDate}
          numberOfGuests={numberOfGuests}
        />
      ))}
    </div>
  );
};

export default Conversation;
